// @flow
import React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {
  CodeTabGroup,
  CodeBlock,
  CodeTab,
  CodegenSnippet,
} from 'docs/components';
import {ContentGroupItem} from 'docs/util';
import {useApiExplorer} from './ApiExplorerProvider';

const messages = defineMessages({
  default: {
    id: 'docsApp.codegenExample.default',
    description: 'Default message in empty request example snippets.',
    defaultMessage: '// Make a request to see code examples.',
  },
});

export const CodegenExample = () => {
  const {
    state: {codegenExample},
  } = useApiExplorer();
  const intl = useIntl();
  const emptyCodeBlocks = [
    {
      lang: '',
      codegenError: null,
      generatedCode: intl.formatMessage(messages.default),
      overriddenCodeBlock: null,
    },
  ];

  if (codegenExample?.error) {
    return (
      <CodeTabGroup
        items={[
          new ContentGroupItem(
            '',
            '',
            (
              <CodeTab
                key="codegen-example"
                id="codegen-example"
                title="Request"
              >
                <CodeBlock numbered={false}>{codegenExample.error}</CodeBlock>
              </CodeTab>
            ),
          ),
        ]}
        codeTabGroupID="codetab_api_explorer_request"
      />
    );
  } else if (codegenExample?.generatedCodeBlocks) {
    return (
      <CodegenSnippet
        generatedCodeBlocks={codegenExample.generatedCodeBlocks}
        codeTabGroupID="codetab_api_explorer_request"
      />
    );
  } else {
    return (
      <CodegenSnippet
        generatedCodeBlocks={emptyCodeBlocks}
        codeTabGroupID="codetab_api_explorer_request"
      />
    );
  }
};
